import { css } from 'styled-components';

/* 2px between stars, which the theme has no token for: the smallest spacing step
   is `xxs` at 4px, and at 4px the row reads as five separate marks rather than as
   one rating. Stated locally rather than rounded up to the nearest token. */
const STAR_GAP = '2px';

export const stars = css`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  gap: ${STAR_GAP};
  line-height: 0;
`;
